// extracted by mini-css-extract-plugin
export default {"serviceItem":"ServiceItem_serviceItem__fzzI5","name":"ServiceItem_name__HF-xW"};